import React from 'react'
import { Input } from './'

export const Number = props => {   
    const customProps = Object.assign({}, { "defaultValue": "", "type": "number" }, props);
    
    return (<Input {...customProps} />)
}

export default Number;